import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";

const MENU_PROPS = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
};

const FlowBuilderRemoveTagModal = ({ open, onSave, data, onUpdate, close }) => {
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          const tag = data.data.tag;
          const { data: result } = await api.get("/tags/list");
          setSelectedTag(tag.id);
          setTags(result);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data } = await api.get("/tags/list");
          setSelectedTag("");
          setTags(data);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedTag) {
      return toast.error("Selecione uma tag para remover");
    }
    
    if (open === "edit") {
      const tag = tags.find((item) => item.id === selectedTag);

      onUpdate({
        ...data,
        data: {
          tag: tag ? tag : "",
        },
      });
    } else if (open === "create") {
      const tag = tags.find((item) => item.id === selectedTag);

      onSave({
        tag: tag ? tag : "",
      });
    }
    handleClose();
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={open === "create" ? `Remover uma tag do fluxo` : `Editar remoção de tag`}
        subtitle="Tira uma tag do contato quando o fluxo chega neste ponto."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField label="Escolha uma tag para remover do contato" help="Esta ação removerá a tag selecionada do contato quando o fluxo for executado">
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              id="remove-tag-select"
              value={selectedTag}
              displayEmpty
              onChange={(e) => {
                setSelectedTag(e.target.value);
              }}
              MenuProps={MENU_PROPS}
              renderValue={() => {
                if (selectedTag === "") {
                  return "Selecione uma tag para remover";
                }
                const tag = tags.find((t) => t.id === selectedTag);
                if (tag === undefined) {
                  return "Nenhuma tag selecionada";
                }
                return tag.name;
              }}
            >
              <MenuItem value="">
                <em>Selecione uma tag para remover</em>
              </MenuItem>
              {tags.length > 0 &&
                tags.map((tag, index) => (
                  <MenuItem dense key={index} value={tag.id}>
                    {tag.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleSaveContact}
        >
          {open === "create" ? `Adicionar Remoção` : "Editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderRemoveTagModal;
